import { Component, OnInit, Input } from '@angular/core';
import { CommercialService } from '../../commercial.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-cq19',
  templateUrl: './cq19.component.html',
  styleUrls: ['./cq19.component.css', '../commercial-questionnaire.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ])
  ]
})
export class Cq19Component implements OnInit {
  @Input() data: any;
  bizname: String;
  questions = [];
  userResponses = [];
  question;
  questionObj;
  disablebutton = false;
  showbutton = true;
  deviceWidth;
  question_sub1;
  question_sub2;

  constructor(private commercialService: CommercialService) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
   }

  ngOnInit() {
    this.commercialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
        if (this.deviceWidth > 768) {
          const question_sub1 = this.question.split('that! ');
          this.question_sub1 = question_sub1[0] + ' that!';
          this.question_sub2 = question_sub1[1];
        }
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'com_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.bizname = obj.fieldValue;
        this.disablebutton = true;
        if (this.deviceWidth < 768) {
          this.getBizname();
        }
      }
    }

    if(_.isEmpty(this.bizname))
    {
      this.showbutton = false;
    }
  }

  enableButton(event) {
    if (_.isEmpty(this.bizname)) {
      this.disablebutton = false;
    } else {
      this.disablebutton = true;
    }
  }

  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  getBizname() {
    if (_.isEmpty(this.bizname)) {
      if (this.deviceWidth < 768) {
        this.commercialService.unSelectService({'currentId': this.data});
      }
    } else {
      const Obj = {
        'com_question_id': this.data,
        'fieldName': 'business_name',
        'fieldValue': this.titleCase(this.bizname)
      };
      this.commercialService.updateResponses(Obj);
      this.next();
    }
  }

  next() {
    this.commercialService.messageService({ 'currentId': this.data });
  }

}
